import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage'; // Ensure you're using the correct AngularFire version
import { Capacitor } from '@capacitor/core';
import { finalize } from 'rxjs/operators';
import { PhotoViewer } from '@capacitor-community/photoviewer';
import { ImageViewerComponent } from '../pickers/image-viewer.component';
import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class PhotoService {
  constructor(private storage: AngularFireStorage, private modalCtrl: ModalController) { }

  uploadImageToFirebase(
    base64Image: string,
    filePath: string
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      // Convert Base64 to Blob
      const blob = this.base64ToBlob(base64Image, 'image/jpeg'); // Adjust MIME type if needed

      // Create a reference to the storage location
      const storageRef = this.storage.ref(filePath);

      // Upload the Blob
      const uploadTask = this.storage.upload(filePath, blob);

      uploadTask
        .snapshotChanges()
        .pipe(
          finalize(() => {
            // Get the download URL
            storageRef.getDownloadURL().subscribe(
              (url) => resolve(url),
              (error) => reject(error)
            );
          })
        )
        .subscribe();
    });
  }

  async deleteImageFromFirebase(downloadUrl: string) {
    const ref = this.storage.storage.refFromURL(downloadUrl); // parses the path for you
    await ref.delete();
  }

  base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64.split(',')[1]); // Extract after the comma
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  async open(url: string) {
    if (Capacitor.isNativePlatform()) {
      await PhotoViewer.show({
        images: [{ url }],
        options: { title: false, share: false }
      });
    } else {
      const modal = await this.modalCtrl.create({
        component: ImageViewerComponent,
        componentProps: { url },
        cssClass: 'image-viewer-modal'
      });
      await modal.present();
    }
  }
}
